import store from '@/store/index';
import { saveUserHitMenuData } from './api';
// 对象（数组）深复制
export const clone = (obj) => {
    return obj ? JSON.parse(JSON.stringify(obj)) : null;
};

// 过滤特殊字符(不过滤中文A-Za-z0-9_-.)
export const filterSpecChar = (val) => {
    return val.replace(/[^\u4e00-\u9fa5\w-.]/g, '');
};

export const isString = val => {
    return Object.prototype.toString.call(val) === '[object String]';
};

export const isNumber = val => {
    return Object.prototype.toString.call(val) === '[object Number]';
};

export const isArray = val => {
    return Object.prototype.toString.call(val) === '[object Array]';
};

export const isObject = val => {
    return Object.prototype.toString.call(val) === '[object Object]';
};

export const isEmptyObject = val => {
    return isObject(val) && Reflect.ownKeys(val).length === 0;
};

export const isDate = val => {
    return Object.prototype.toString.call(val) === '[object Date]';
};

export const isUndefined = val => {
    return Object.prototype.toString.call(val) === '[object Undefined]';
};

export const isNull = val => {
    return Number.isNaN(val);
};

export const isNaN = val => {
    // eslint-disable-next-line no-self-compare
    return Object.prototype.toString.call(val) === '[object Number]' && (val !== val);
};

export const isValid = val => {
    return !isUndefined(val) && !isNull(val) && !isNaN(val);
};

export const isSymbol = val => {
    return typeof val === 'symbol' || Object.prototype.toString.call(val) === '[object Symbol]';
};

/*
*   判断两个时间戳的差值
*   @currentDate 当前时间
*   @previousDate 之前时间
*   @difference 两个时间的差值(毫秒)，默认值为24小时
*/
const millisecond = 1000;
const sixty = 60;
const timeOfDay = 24;
export const DateDiff = (currentDate, previousDate, difference = millisecond * sixty * sixty * timeOfDay) => {
    return currentDate - previousDate < difference;
};

/*
*   lodash 实用函数移植
*/
const INFINITY = 1 / 0;
const reEscapeChar = /\\(\\)?/g;
const rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

const symbolProto = Symbol ? Symbol.prototype : undefined;
const symbolToString = symbolProto ? symbolProto.toString : undefined;

function arrayMap(array, iteratee) {
    /* eslint-disable */
    var index = -1;
    var length = array === null ? 0 : array.length;
    var result = Array(length);

    while (++index < length) {
        result[index] = iteratee(array[index], index, array);
    }
    return result;
    /* eslint-disable */
}

function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value === 'string') {
        return value;
    }
    if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result === '0' && (1 / value) === -INFINITY) ? '-0' : result;
}
function toString(value) {
    return value == null ? '' : baseToString(value);
}
function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === 46) {
        result.push('');
    }
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
}
function castPath(value, object) {
    if (isArray(value)) {
        return value;
    }
    return Reflect.has(object, value) ? [value] : stringToPath(toString(value));
}
function toKey(value) {
    if (typeof value === 'string' || isSymbol(value)) {
        return value;
    }
    var result = (value + '');
    return (result === '0' && (1 / value) === -INFINITY) ? '-0' : result;
}
function baseGet(object, path) {
    path = castPath(path, object);

    var index = 0;
    var length = path.length;

    while (object != null && index < length) {
        object = object[toKey(path[index++])];
    }
    return (index && index === length) ? object : undefined;
}

export const get = (object, path, defaultValue) => {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
};

function setLocalStorage(info, frontUrl, resourceCode) {
    if (!localStorage.getItem('authMenusStatistics')) {
        const storage = assembleData(info, frontUrl, resourceCode);
        localStorage.setItem('authMenusStatistics', JSON.stringify(storage));
    } else {
        const authMenusStatistics = JSON.parse(localStorage.getItem('authMenusStatistics'));
        const hasUser = authMenusStatistics.find(item => item.userCode === store.state.user.userCode);
        if (!hasUser) {
            const storage = assembleData(info, frontUrl, resourceCode);
            localStorage.setItem('authMenusStatistics', JSON.stringify([...authMenusStatistics, ...storage]));
        } else {
            const hasResource = hasUser.resourceDataList.find(item => item.resourceCode === resourceCode);
            if (hasResource) {
                ++hasResource.actionHit;
                localStorage.setItem('authMenusStatistics', JSON.stringify(authMenusStatistics));
            } else {
                const storage = assembleData(info, frontUrl, resourceCode);
                hasUser.resourceDataList = [...hasUser.resourceDataList, ...storage[0].resourceDataList];
                localStorage.setItem('authMenusStatistics', JSON.stringify(authMenusStatistics));
            }
        }
    }
};

function assembleData(info, frontUrl, resourceCode) {
    const currentApp = store.state.appList.find(item => item.applicationCode === store.state.applicationCode);
    const storage = [
        {
            userCode: store.state.user.userCode,
            resourceDataList: [
                {
                    applicationCode: currentApp.applicationCode,
                    applicationName: currentApp.applicationName,
                    aliasName: currentApp.aliasName,
                    resourceCode: resourceCode,
                    path: info,
                    url: frontUrl,
                    actionHit: 1
                }
            ]
        }
    ];
    return storage;
}

function sendMenuData() {
    const authMenusStatistics = JSON.parse(localStorage.getItem('authMenusStatistics'));
    if (authMenusStatistics) {
        saveUserHitMenuData(authMenusStatistics).then(res => {
            if (+res.code === 0) {
                localStorage.removeItem('authMenusStatistics');
            }
        });
    }
}
export default {
    clone,
    filterSpecChar,
    isString,
    isNumber,
    isArray,
    isObject,
    isEmptyObject,
    isDate,
    isUndefined,
    isNull,
    isNaN,
    isValid,
    isSymbol,
    DateDiff,
    get,
    setLocalStorage,
    sendMenuData
};